


































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Skill } from '@/@types/LibraryComponent';
import JobSearchTermsModule from '@/components/jobList/accordion/JobSearchTermsModule.vue';

@Component({
  components: {
    JobSearchTermsModule,
  },
})
export default class JobSearchAccordion extends Vue {

  private keywordField = {
    title: 'キーワード',
    keywords: [],
    label: 'キーワードで検索',
    icon: 'mdi-magnify',
    selected: true
  }
  private conditions = [
    {
      title: '職種',
      icon: 'mdi-account-hard-hat',
      route: '',
      selected: true,
      items: [
        {
          title: 'エンジニアリング',
          selected: false,
        },
        {
          title: 'デザイン・アート',
          selected: false,
        },
        {
          title: '編集・ライティング',
          selected: false,
        },
        {
          title: 'PM・Webディレクション',
          selected: false,
        },
        {
          title: 'コンサルティング',
          selected: false,
        },
        {
          title: 'マーケティング',
          selected: false,
        },
        {
          title: 'セールス',
          selected: false,
        },
        {
          title: 'コーポレート',
          selected: false,
        },
        {
          title: 'その他',
          selected: false,
        },
      ],
    },
    {
      title: 'スキル',
      icon: 'mdi-arm-flex',
      route: '',
      selected: true,
    },
    {
      title: '推定月収',
      icon: 'mdi-currency-jpy',
      route: '',
      selected: true,
      item: {
        lowPrice: 10,
        price: 50,
        maxPrice: 300,
        minPrice: 0,
        priceRange: [10, 50],
        unit: '万円',
      },
    },
    {
      title: '契約形態',
      icon: 'mdi-gavel',
      route: '',
      selected: true,
      items: [
        {
          title: '正社員',
          selected: false,
        },
        {
          title: '派遣社員',
          selected: false,
        },
        {
          title: '契約社員',
          selected: false,
        },
        {
          title: 'アルバイト',
          selected: false,
        },
        {
          title: 'インターン',
          selected: false,
        },
        {
          title: '委任',
          selected: false,
        },
        {
          title: '請負',
          selected: false,
        },
      ],
    },
    {
      title: '勤務地',
      icon: 'mdi-map-marker',
      route: '',
      selected: true,
      item: {
        label: '勤務地で検索',
        address: '東京都新宿区',
        latitude: null,
        lonqitude: null,
        zoomLevel: 13.0,
      },
    },
    {
      title: '特徴',
      icon: 'mdi-clipboard-text-outline',
      route: '',
      selected: true,
      items: [
        {
          title: '社長がプログラミングできる',
          selected: false,
        },
        {
          title: 'フレックス勤務',
          selected: false,
        },
        {
          title: 'リモート勤務可能',
          selected: false,
        },
        {
          title: 'オンライン面談OK',
          selected: false,
        },
        {
          title: 'スタートアップ',
          selected: false,
        },
        {
          title: 'グローバル展開している',
          selected: false,
        },
        {
          title: '自社サービスを展開している',
          selected: false,
        },
      ]
    },
    {
      title: '並び替え',
      icon: 'mdi-sort-alphabetical-ascending',
      route: '',
      selectedSortKey: '',
      items: [
        {
          title: 'おすすめ順',
          selected: false,
        },
        {
          title: '単価が高い順',
          selected: false,
        },
        {
          title: '単価が安い順',
          selected: false,
        },
        {
          title: '新着順',
          selected: false,
        },
        {
          title: '企業の評価が高い順',
          selected: false,
        },
      ]
    }
  ];
  private skills: Array<Skill> = require('@/repository/mock/dummyData/job/skills.json').skills;
  private selectedSkillType: string = '言語';
  private dummyGmap: string = require('@/assets/gmaptest.png');

  private panels: Array<number> = [0];
  private openY: number = 0;
  private unscrollableBuffer: number = 100;
  private menuIsOpen: boolean = false;
  private mapModal: boolean = false;

  private get isOpen() {
    if (this.mainIsOpen) {
      this.panels.splice(0);
    }
    return this.panels.length !== 0;
  }

  private get isFlat() {
    return this.isOpen;
  }

  private get workplace() {
    return this.conditions.find((e) => e.title === '勤務地');
  }

  private get skillTypes() {
    return this.skills.map((e) => e.type).filter((e, i, self) => self.indexOf(e) === i);
  }

  private get filteredSkills() {
    return this.skills.filter((e) => e.type === this.selectedSkillType);
  }
  private get selectedSkills() {
    return this.skills.filter((e) => e.selected);
  }

  // 求人案件一覧から詳細に遷移したことを検知するプロパティ
  @Prop()
  private mainIsOpen: boolean = false;

  // アコーディオンメニューを明示的に閉じたという状態を格納するプロパティ
  private isClosedAccordionExplicitly: boolean = false;

  private closeAccordionExplicitly() {
    this.isClosedAccordionExplicitly = true;
  }


  private onScroll() {
    const scrollY = window.scrollY;
    const topBuffer = this.openY - this.unscrollableBuffer;
    const bottomBuffer = this.openY + this.unscrollableBuffer;

    if (this.isClosedAccordionExplicitly) {
      return
    }

    if (this.isOpen) {
      if (topBuffer < scrollY && scrollY < bottomBuffer) {
        return;
      }
      if (scrollY > 300) {
        this.panels.splice(0);
        this.openY = scrollY;
      }
    } else {
      if (scrollY === 0) {
        this.panels.push(0);
        this.openY = scrollY;
      }
    }
  }

  private getOpenY() {
    this.openY = window.scrollY;
  }

  private selectSkillType(skillType: string) {
    this.selectedSkillType = skillType;
  }

  private switchMapModal() {
    this.mapModal = !this.mapModal;
  }
}
